import {z} from "zod";

const schema = z.object({
	id: z.string(),
	name: z.string(),
	url: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const FileModel = {schema, model};
export type IFileModel = z.infer<typeof FileModel.model>;
export const DEFAULT_FILE: IFileModel = {
	id: "",
	name: "",
	url: ""
};
